export class PostCertificadoEmpresaA1Request {
  arquivoCertificado64: string;
  senhaCertificado: string;
  cnpjLogado: string;
}